// extracted by mini-css-extract-plugin
export default {"item":"commentItem_item__uEfoD","header":"commentItem_header__4iJUw","date":"commentItem_date__OB3K3","name":"commentItem_name__EuXPa","text":"commentItem_text__2OHpZ"};